"use client";

import React from "react";
import { useRouter } from "next/navigation";

import TrackingScripts from "@/app/[lang]/p/[qrId]/TrackingScripts";

import { isValidQrReference } from "@/utils/qrEditorHelper";

import { QREditorAPItoDataConversor } from "@/services/ApiConversorService/QREditor";
import { QRViewPageTemplate } from "@/templates/QRViewPageTemplate";
import { QRProps } from "@/contexts/QREditorContext/types";
import { useApiWithLayout } from "@/hooks/api";

import { QRCodeScanResponse } from "@/interface/api/getFindQr/types";
import getScanHandler from "@/interface/api/getScan";

import { QrStatus, Tracking } from "@/types/qr";
import { IQrViewPage } from "@/types/types";

const NOT_FOUND_MESSAGE = "not found";

export const QRViewContainer = ({ params: { lang, qrId } }: IQrViewPage) => {
  const [qrData, setQrData] = React.useState<QRProps<any> | undefined>(undefined);
  const [trackingIds, setTrackingIds] = React.useState<Tracking>(undefined);
  const router = useRouter();

  const {
    request: requestScan,
    data: dataScan,
    error: errorScan,
  } = useApiWithLayout(getScanHandler.getScan);

  const qrCodeId = qrId;

  React.useEffect(() => {
    if (qrCodeId) {
      isValidQrReference(qrCodeId) ? requestScan({ qrCodeId }) : router.replace("/404");
    }
  }, [qrCodeId]);

  React.useEffect(() => {
    if (errorScan?.status === 402) router.push("/inactive");
    if (errorScan?.status === 400 || errorScan?.status === 404) {
      if (errorScan.data.message?.includes(NOT_FOUND_MESSAGE)) router.replace("/404");
    }
  }, [errorScan]);

  React.useEffect(() => {
    if (dataScan) {
      const dataQR: QRCodeScanResponse = dataScan.data;
      if (dataQR.status === QrStatus.ACTIVE.toLowerCase()) {
        setQrData(QREditorAPItoDataConversor.getQRData(dataQR));
        setTrackingIds(dataQR?.content?.tracking || undefined);
      } else router.push("/inactive");
    }
  }, [dataScan]);

  return (
    <>
      {trackingIds && <TrackingScripts trackingIds={trackingIds} />}
      <QRViewPageTemplate
        qrData={qrData}
        language={lang}
      />
    </>
  );
};
